import * as React from "react";
import styles from "./SimpleDialog.module.scss";

interface SimpleDialogProps {
  open: boolean;
  title: string;
  onClose?: () => void;
  children: React.ReactNode;
}

export const SimpleDialog: React.FC<SimpleDialogProps> = (props) => {
  const dialogRef = React.useRef<HTMLDialogElement>(null);

  React.useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;

    if (props.open) {
      if (!dialog.open) dialog.showModal();
    } else {
      if (dialog.open) dialog.close();
    }
  }, [props.open]);

  return (
    <dialog
      ref={dialogRef}
      className={styles.dialog}
      onClose={props.onClose}
    >
      <div className={styles.titleBar}>
        <h3 className={styles.title}>{props.title}</h3>
        {props.onClose && (
          <button
            className={styles.closeButton}
            onClick={props.onClose}
            type="button"
            aria-label="Close"
          >
            &times;
          </button>
        )}
      </div>
      <div className={styles.content}>{props.children}</div>
    </dialog>
  );
};
